import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CanvasMenuButton from '../menu/CanvasMenuButton';
import CanvasMenuDropDown from '../menu/CanvasMenuDropDown';

export default class CanvasTextAlign extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    onUpdate: PropTypes.func,
    updateInfo: PropTypes.func,
    textAlign: PropTypes.string
  };

  groupApplyAlign = (alignment) => {
    const { canvasRef, onUpdate, updateInfo } = this.props;

    const activeObjects = canvasRef.getActiveObjects();

    activeObjects.forEach((object) => {
      object.set({ textAlign: alignment });
    });

    canvasRef.renderAll();

    onUpdate();
    updateInfo();
  };

  render() {
    const { textAlign } = this.props;

    return (
      <CanvasMenuDropDown
        icon="align"
        toolTip="canvas-editor.text.align"
        active={textAlign}
      >
        <CanvasMenuButton
          onClick={this.groupApplyAlign.bind(this, 'left')}
          toolTip="canvas-editor.text.alignment.left"
          icon="align-left"
          active={textAlign === 'left'}
          label="canvas-editor.text.alignment.left"
        />

        <CanvasMenuButton
          onClick={this.groupApplyAlign.bind(this, 'center')}
          toolTip="canvas-editor.text.alignment.center"
          icon="align-center"
          active={textAlign === 'center'}
          label="canvas-editor.text.alignment.center"
        />

        <CanvasMenuButton
          onClick={this.groupApplyAlign.bind(this, 'right')}
          toolTip="canvas-editor.text.alignment.right"
          icon="align-right"
          active={textAlign === 'right'}
          label="canvas-editor.text.alignment.right"
        />
      </CanvasMenuDropDown>
    );
  }
}
